export const SettingsGlossary = {
    RESET_BUTTON_DEFAULT_OFFSET: "80px",
    RESET_BUTTON_WITH_SWITCH_OFFSET: "110px",
    RESET_BUTTON_NORMAL_MODE_OFFSET: "30px",

    SHOW_SWITCHER_UI_CLASS: "show-switcher-ui"
};
